<template>
  <main class="tag-page-wrap h-100">
    <TagTutorial :tagId="tagId" v-if="showTagTutorial"></TagTutorial>
    <PageNotFound v-if="pageNotFound"></PageNotFound>
    <div class="container d-flex flex-column h-100" v-else>

      <AddContentToUserGroup :type="'tag'" :id="tagId" :img="likeImage" :name="tagInfo.name_plural" v-if="userGroupAdd" @close="userGroupAdd = false;"></AddContentToUserGroup>

      <CustomDistanceOptions v-if="customDistance" @selectOption="selectCustomDistanceOption" @close="customDistance = !customDistance"></CustomDistanceOptions>

      <CustomAddress v-if="customAddress" :addressLookup="true" @addressReady="addressReady" @close="customAddress = false;"></CustomAddress>

      <DistanceFromUserData v-if="distFromUserData" @close="distFromUserData = false;" :type="distFromUserDataType" @dataSelected="getDistanceFromUserData"></DistanceFromUserData>

      <div class="row h-100">

        <div class="col-md-7 col-12">

          <Images v-if="showImages" :imageData="imageData"></Images>

          <Map :mapData="tagDataFiltered" :tagId="tagId" @mapInFullscreen="toggleMap" :hasFilters="hasFilters" @toggleFullscreenFilters="openFullscreenFilters = !openFullscreenFilters;" v-else></Map>

          <div class="row tag-basic-information-box white-box">
            <div class="col-12 p-0">
              <Toolbar :type="'tag'" :id="tagId" :name="tagInfo.name_plural" :img="likeImage" :showImages="showImages" @switchBetweenImageAndMap="showImages = !showImages" @addItemToUserGroup="userGroupAdd = true"></Toolbar>

              <div class="d-block d-sm-none no-pad-both" style="margin-top: 5px;" v-if="tagId == 342">
                <UserWishButton v-if="tagId == 342"></UserWishButton>
    					</div>

            </div>

            <div class="col-12 d-none d-sm-block">
              <h1 class="tag-headline" v-if="tagInfo != false">{{ tagInfo.name_plural }}</h1>
              <UserWishButton v-if="tagId == 342"></UserWishButton>
            </div>

            <div class="col-12 d-none d-sm-block" id="tag-description">
              <DescriptionBox :descriptionData="tagDescription"></DescriptionBox>
            </div>
          </div>

        </div>

        <div class="col-md-5 col-12 tag-information-wrap no-pad-both-xs">
          <TagFilters v-if="hasFilters" ref="tagFilters" :tagData="tagData" @dataFiltered="dataFiltered" :class="{'filter-fullscreen': mapInFullscreen, 'show-filters': openFullscreenFilters}" @close="openFullscreenFilters = false"></TagFilters>

          <div class="tag-information white-box">

            <div class="d-block d-sm-none" id="tag-description-xs">
              <DescriptionBox :descriptionData="tagDescription"></DescriptionBox>
            </div>

            <TagList :tagData="tagDataFiltered" :tagId="tagId" :tagInfo="tagInfo" @sortBy="sortList" @toggleCustomDistanceOptions="customDistance = !customDistance"></TagList>
          </div>

        </div>

      </div>
    </div>
  </main>
</template>

<script>
import DataManager from '@/assets/DataManager.js'
import TagList from '@/components/tag/TagList.vue'
import LatLngTools from '@/assets/LatLngTools.js'
import Map from '@/components/map/Map.vue'
import Toolbar from '@/components/Toolbar.vue'
import Images from '@/components/Images.vue'
import TagFilters from '@/components/tag/TagFilters.vue'
import CustomDistanceOptions from '@/components/tag/CustomDistanceOptions.vue'
import DistanceFromUserData from '@/components/tag/DistanceFromUserData.vue'
import axios from 'axios'
import CustomAddress from '@/components/customAddress/CustomAddress.vue'
import SearchDataParser from '@/assets/SearchDataParser.js'
import AddContentToUserGroup from '@/components/profile/AddContentToUserGroup.vue'
import DescriptionBox from '@/components/DescriptionBox.vue'
import PageNotFound from '@/components/PageNotFound.vue'
import LiveData from '@/assets/LiveData.js'
import UserWishButton from '@/components/tag/UserWishButton.vue'
import TagTutorial from '@/components/tutorials/TagTutorial.vue'

export default {
  data() {
    return {
      tagData: {},
      tagDataFiltered: false,
      tagList: '',
      tagInfo: false,
      imageData: [],
      likeImage: false,
      hasFilters: false,
      showImages: true,
      userGroupAdd: false,
      mapInFullscreen: false,
      openFullscreenFilters: false,
      customDistance: false,
      customAddress: false,
      distFromUserData: false,
      distFromUserDataType: false,
      tagDescription: '',
      liveDataTimeout: false,
      pageNotFound: false,
      showTagTutorial: false,
    }
  },
  props: {
    tagId: {
      type: String,
      required: true,
    },
    startup: {
      default: false,
    }
  },
  components: {
    TagList, Map, Toolbar, Images, TagFilters, CustomDistanceOptions, CustomAddress, DistanceFromUserData, AddContentToUserGroup, DescriptionBox, PageNotFound, UserWishButton, TagTutorial
  },
  watch: {
    tagData() {
      this.getImageData();
    },
    $route(to, from) {
      this.getTagData();
    }
  },
  beforeCreate() {
    this.$root.$emit('toggleLoadingScreen', true);
  },
  created() {
    this.getTagData();
  },
  mounted() {
		this.$HelperFunctions.setScreenReaderFocus();
    if(localStorage.getItem('OdenseRundt-TutorialTag') == 'true') {
      this.showTagTutorial = true;
    }
  },
  beforeDestroy() {
    clearInterval(this.liveDataTimeout);
  },
  methods: {
    getTagData() {
      clearInterval(this.liveDataTimeout);
      DataManager.getData([
        DataManager.tagList,
      ], (response) => {
        this.tagList = response[0].data;
        for(var i in this.tagList) {
          if(this.tagList[i].id == this.tagId) {
            this.tagInfo = this.tagList[i];
          }
        }
        if(this.tagInfo != false) {
          this.hasFilters = (this.tagInfo.filter && this.tagInfo.filter == true) ? true : false;
          let url = (this.tagInfo.filter && this.tagInfo.filter == true) ? '-dk-full.json' : '-dk-light.json';
          DataManager.getData([
            DataManager.newTags+this.tagId+url,
          ], (response) => {
            this.tagData = response[0].data;
            console.log(this.tagData);
            this.createPageInfo();
            this.setTagSettings();
            this.processTagData();
          });
        }
        else {
          this.pageNotFound = true;
          this.$root.$emit('toggleLoadingScreen', false);
        }
      });
    },

    processTagData() {
      this.getDistanceToPlaces().then(() => {
        this.$HelperFunctions.checkForLiveData(this.tagData.features).then((liveDataFound) => {
          if(liveDataFound) {
            LiveData.getLiveData().then(() => {
              this.finishData();
              this.liveDataTimeout = setInterval(() => {
                LiveData.getLiveData().then(() => {
                  this.finishData();
                });
              }, 60000);
            });
          }
          else {
            this.finishData();
          }
        });
      });
    },

    finishData() {
      //If no filters, dont wait for filter to process data
      if(!this.hasFilters) {
        this.tagDataFiltered = {features: this.tagData.features};
      }
      else {
        this.$refs.tagFilters.filterPlaces();
      }
      this.$root.$emit('toggleLoadingScreen', false);
    },

    dataFiltered(data) {
      this.tagDataFiltered = {features: data};
    },

    createPageInfo() {
      this.$HelperFunctions.scrollToTop();
      this.$HelperFunctions.setPageTitle(this.tagInfo.name_plural);
      let description = (this.tagInfo.desc != undefined) ? this.tagInfo.desc.replace(/<\/?[^>]+(>|$)/g, "").slice(0, 200) : '';
      this.$HelperFunctions.generateMetaTags(this.tagInfo.name_plural, description);
      this.tagDescription = (this.tagInfo.desc != undefined) ? this.tagInfo.desc : '';
    },

    setTagSettings() {
      if(this.startup != false) {
        this.showImages = (this.startup == 'map' || this.startup == 'mapFull' || this.startup == 'true') ? false : true;
      }
      else if(this.tagInfo.showFirst == 'img' || this.tagInfo.showFirst == 'spot') {
        this.showImages = true;
      }
      else if(this.tagInfo.showFirst == 'map') {
        this.showImages = false;
      }
    },

    getDistanceToPlaces() {
      return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition((position) => {
          //Get address for user position
          axios.get('https://dawa.aws.dk/adgangsadresser/reverse?x='+position.coords.longitude+'&y='+position.coords.latitude)
          .then((response) => {
            let positionAddress = response.data.vejstykke.navn+' '+response.data.husnr;
            document.getElementById('position-address').innerHTML = 'Afstand er beregnet ud fra din position ('+positionAddress+').';
            this.calculateDistanceToPlaces(position).then(() => {
              resolve();
            });
          })
          .catch((error) => {
            console.log(error);
            this.calculateDistanceToPlaces(false).then(() => {
              resolve();
            });
          });
        }, (error) => {
          this.calculateDistanceToPlaces(false).then(() => {
            resolve();
          });
        });
      });
    },

    calculateDistanceToPlaces(position) {
      return new Promise((resolve) => {
        var latLngTools = new LatLngTools();

        this.tagData.features.forEach((feature) => {
          if(position == false) {
            feature.distance = '?';
          }
          else {
            if(feature.geometry.type == 'Point') {
              var itemDistance = latLngTools.distance(position.coords.latitude, position.coords.longitude, feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
            }
            else if(feature.geometry.type == 'LineString') {
              var itemDistance = latLngTools.distance(position.coords.latitude, position.coords.longitude, feature.geometry.coordinates[0][1], feature.geometry.coordinates[0][0]);
            }
            else if(feature.geometry.type == 'Polygon') {
              var polygon = L.polygon(feature.geometry.coordinates);
              var itemDistance = latLngTools.distance(position.coords.latitude, position.coords.longitude, feature.geometry.coordinates[0][0][1], feature.geometry.coordinates[0][0][0]);
            }
            this.$set(feature, 'distance', Math.round(itemDistance));
          }
        });
        resolve();
      });
    },

    toggleMap(bool) {
      this.mapInFullscreen = bool;
    },

    selectCustomDistanceOption(option) {
      this.customDistance = false;
      this.customAddress = false;
      this.distFromUserData = false;
      if(option == 'address') {
        this.customAddress = true;
      }
      else if(option == 'userFavorite' || option == 'userAddress') {
        this.distFromUserData = true;
        this.distFromUserDataType = (option == 'userFavorite') ? 'place' : 'address';
      }
    },

    addressReady(result) {
      document.getElementById('position-address').innerHTML = 'Afstand er beregnet ud fra '+result.name+'.';
      this.calculateDistanceToPlaces(result).then(() => {
        this.finishData();
      });
      this.customAddress = false;
    },

    getDistanceFromUserData(item) {
      var position = {
        coords: {
          latitude: false,
          longitude: false,
        }
      }
      document.getElementById('position-address').innerHTML = 'Afstand er beregnet ud fra '+item.name+'.';
      if(item.coords) {
        position.coords.latitude = item.coords.lat;
        position.coords.longitude = item.coords.lng;
        this.calculateDistanceToPlaces(position).then(() => {
          this.finishData();
        });
      }
      else {
        DataManager.getData([
      			DataManager.searchData,
      			DataManager.searchDataExpanded,
      		], (response) => {
        		let searchDataExpanded = SearchDataParser(response[0].data, response[1].data).searchDataExpanded;
            let place = searchDataExpanded.find(element => element.placeId == item.value);
            position.coords.latitude = place.lat;
            position.coords.longitude = place.lng;
            this.calculateDistanceToPlaces(position).then(() => {
              this.finishData();
            });
      	});
      }
    },

    sortList(sortBy) {
      console.log(this.tagDataFiltered);
      if(sortBy == 'name') {
        this.$HelperFunctions.sortArrayByString(this.tagDataFiltered.features, 'name');
      }
      else if(sortBy == 'distance') {
        this.$HelperFunctions.sortArrayByInt(this.tagDataFiltered.features, 'distance');
      }
    },

    getImageData() {
      this.imageData = [];
  		if(this.tagInfo.image && this.tagInfo.image != '' && this.tagInfo.image != 0 && this.tagInfo.image != "" && this.tagInfo.image != undefined) {
  			//var resolution = this.$HelperFunctions.checkForHighestResolution(this.tagInfo.image);
        if(this.tagInfo.images.length == 1) {
    			this.$HelperFunctions.checkForHighestResolution(this.tagInfo.image).then((resolution) => {
            var imgCredit = (this.tagInfo.photoCredits[this.tagInfo.image] != undefined && this.tagInfo.photoCredits[this.tagInfo.image] != false) ? this.tagInfo.photoCredits[this.tagInfo.image] : '';
      			var options = {hasImage: true, resolution: resolution, src: this.tagInfo.image, imgCredit: imgCredit, imageName: this.tagInfo.name_plural};
            this.imageData.push(options);
            this.likeImage = options.src;
          });
        }
  			else if(this.tagInfo.images.length > 1) {
          this.tagInfo.images.forEach(image => {
    				this.$HelperFunctions.checkForHighestResolution(image).then((extraImageResolution) => {
    					var imgCredit =(this.tagInfo.photoCredits[image] != undefined && this.tagInfo.photoCredits[image] != '' && this.tagInfo.photoCredits[image] != 0) ?this.tagInfo.photoCredits[this.tagInfo.images[i]] : '';
    					var options = {hasImage: true, resolution: extraImageResolution, src: image, imgCredit: imgCredit, imageName: this.tagInfo.name_plural};
              this.imageData.push(options);
            });
          });
  			}
  		}
    },
  },
}
</script>

<style lang="scss" scoped>
  .tag-page-wrap {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  a {
    text-decoration: underline;
  }

  .tag-headline {
  	position: relative;
    display: inline;
  	line-height: 50px;
  	font-size: 20px;
  	margin: 0px;
  }

  .tag-basic-information-box {
  	margin-top: 10px;
  }

  #tag-description {
  	padding-top: 10px;
  }

  /*Landscape - MD*/
  @media screen and (min-width: 992px) and (orientation: landscape) {
  	#tag-description {
  		overflow-y: auto;
  	}
  	.tag-information-wrap {
      height: 100%;
      overflow-y: auto;
  	}
  	.tag-basic-information-box {
  		margin-top: 15px;
  	}
  	.tag-information {
  		min-height: 100%;
  	}
  }
  /*Portrait - XS*/
  @media screen and (max-width: 767px) and (orientation: portrait) {
  	.tag-information {
  		height: auto !important;
  		padding: 0px 5px 0px 5px;
  	}
  	#tag-description-xs {
  		padding-top: 10px;
  	}
  }
  /*Portrait - SM*/
  @media screen and (min-width: 768px) and (max-width: 991px) and (orientation: portrait) {
  	.tag-information-wrap {
  		height: auto !important;
  	}
  	.tag-information {
  		margin-top: 15px;
  		padding-top: 15px;
  	}
  	.tag-basic-information-box {
  		height: auto !important;
  		padding: 0px 5px 0px 5px;
  	}
  }
</style>
